import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Card } from 'shared/mui/Card';

export const GatewayRuleCardStyled = styled(Card)({
  border: '1px solid rgba(0, 0, 0, 0.08)',
  marginBottom: '8px',
});

export const GatewayRuleCardHeaderStyled = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  padding: '16px',
});

export const GatewayRuleCardHeaderContentStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  minWidth: 0,
  width: '100%',
});

export const GatewayRuleCardHeaderActionsStyled = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'space-between',
});
